
















import { mixins, Component, Prop } from 'nuxt-property-decorator'
import globalStyling from '~/mixins/globalStyling'

@Component({
  name: 'ShareModal',
  mixins: [globalStyling],
})
export default class ShareModal extends mixins(globalStyling) {
  @Prop({ default: '' }) url: string
  copied: boolean = false

  async copy_to_clipboard(): Promise<void> {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(this.url)
        this.copied = true
      } catch (err) {
        console.error('Failed to copy link to clipboard!')
        console.log(err)
      } finally {
        setTimeout(() => (this.copied = false), 1500)
      }
    } else {
      console.warn("Browser doesn't support clipboard operations")
    }
  }
}
